<div class="sidenav__inner">
  <ng-content></ng-content>
</div>
